import Vue from 'vue'
import Router from 'vue-router'
import Welcome from '@/views/Welcome'
import notFound from '@/views/notFound'
import home from '@/views/home'
import System from '@/views/system'
import ChangePassword from '@/views/ChangePassword'
import AnnouncementDetail from '@/views/home/AnnouncementDetail'
import More from '@/views/home/More'
import Preview from '@/views/home/Preview'
Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'Welcome',
      component: Welcome,
      meta: {
        keepAlive: false // 不需要被缓存
      }
    },
    {
      path: '/home/:message?',
      name: 'home',
      component: home,
      meta: {
        keepAlive: false // 不需要被缓存
      }
    },
    {
      path: '/ChangePassword',
      name: 'ChangePassword',
      component: ChangePassword,
      meta: {
        keepAlive: false // 不需要被缓存
      }
    },
    {
      path: '/system',
      name: '/system',
      component: System,
      meta: {
        keepAlive: false // 不需要被缓存
      }
    },
    {
      path: '/home/AnnouncementDetail',
      name: '/home/AnnouncementDetail',
      component: AnnouncementDetail,
      meta: {
        keepAlive: false // 不需要被缓存
      }
    },
    {
      path: '/home/More',
      name: '/home/More',
      component: More,
      meta: {
        keepAlive: false // 不需要被缓存
      }
    },
    {
      path: '/home/Preview',
      name: '/home/Preview',
      component: Preview,
      meta: {
        keepAlive: false // 不需要被缓存
      }
    },
    // {
    //   path: '/backURL/:message',
    //   name: 'backPage',
    //   component: home
    // },
    {
      path: '/*',
      name: 'notFound',
      component: notFound,
      meta: {
        keepAlive: false // 不需要被缓存
      }
    }
  ],
  scrollBehavior: () => {
    history.pushState(null, null, document.URL)
  }
})
// 导航守卫
// 使用 router.beforeEach 注册一个全局前置守卫，判断用户是否登陆
router.beforeEach((to, from, next) => {
  let token = Welcome.methods.getLocalStorage('Authorization')
  if (!(token == null || token === '')) {
    if (to.path === '/') {
      next('/home')
    } else
    if (to.path === 'home') {
      next()
    } else {
      next()
    }
  } else if (to.path === '/') {
    next()
  } else {
    next()
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js